import React from "react";
import { useSelector } from "react-redux";
import style from "./measurementStatus.module.scss";
import { Button } from "../../../primary";
import { MeasurementLoader } from "./measurementLoader";

export const MeasurementStatus = ({ showMeasurementModal, pendingRetires, maxPendingRetries }) => {
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };

  return (
    <div className="col w-100 pl-4 pr-4 text-center">
      <div className={style.btns_top_space}>
        <div className="mb-3">
          {measurementData?.status === "pending" && (
            <>
              <MeasurementLoader />
              {pendingRetires >= maxPendingRetries && (
                <span style={{ fontSize: 18 }}>It's taking longer than usual, please check back after 5 mins.</span>
              )}
            </>
          )}
          {measurementData?.status !== "do_manual_trace" && measurementData?.status !== "pending" && (
            <>
              Unable to process the photo, please enter the measurements manually. <br />
              <p className={`${style.dim_man_p}`}>
                Click{" "}
                <Button
                  type="button"
                  value="Dimensions"
                  id="autoMeasurement"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  onClick={() => showMeasurementModal("Dimensions")}
                />{" "}
                to manually enter the measurements.
              </p>
            </>
          )}
          {measurementData?.status === "do_manual_trace" && (
            <>
              <p className={`${style.dim_man_p}`}>
                <Button
                  type="button"
                  value="Tap Here"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  id="autoMeasurement"
                  onClick={() => {
                    showMeasurementModal("Retrace Wound Edges");
                  }}
                />{" "}
                and do a high-level wound trace
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
